function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.0437 29.0163H12.5807C11.962 29.0163 11.4918 28.4603 11.5945 27.8502L13.5383 16.3069C13.729 15.1745 15.366 15.2039 15.5159 16.3424L17.0351 27.8858C17.114 28.4847 16.6478 29.0163 16.0437 29.0163Z",
  fill: "#2F9BFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.3931 6.8214C16.5357 9.268 16.3 13.2108 14.6906 13.4849C14.5713 13.5052 14.4482 13.4915 14.3315 13.4596C12.3752 12.924 12.5177 9.80528 12.6253 6.8214C12.7362 3.74997 13.6227 -3.05176e-05 14.5092 -3.05176e-05C15.3958 -3.05176e-05 16.2454 4.28569 16.3931 6.8214Z",
  fill: "#2F9BFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99152 15.7748C9.06013 14.4198 12.6176 12.6306 13.6531 13.8393C13.7344 13.9343 13.7853 14.0519 13.8154 14.1733C14.2913 16.096 11.4951 17.5499 8.83349 18.9652C6.08938 20.4244 2.37174 21.5698 1.93833 20.8192C1.50493 20.0685 4.84299 17.182 6.99152 15.7748Z",
  fill: "#2F9BFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1574 18.9088C17.9497 17.7948 14.6214 15.6086 15.1505 14.1075C15.192 13.9896 15.2685 13.8866 15.3586 13.7999C16.7857 12.4264 19.4429 14.1211 21.9994 15.7184C24.6352 17.3653 27.486 20.0121 27.0526 20.7628C26.6192 21.5135 22.4504 20.0659 20.1574 18.9088Z",
  fill: "#2F9BFF"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.5,
  cy: 13.6537,
  r: 2,
  fill: "#2F9BFF",
  stroke: "#2F4459"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M2.10449 13.3255C0.37129 5.66629 5.10974 2.78749 8.36146 1.99997",
  stroke: "#2F9BFF",
  strokeWidth: 1.5
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.03076 12.3667C5.10557 8.27814 7.63497 6.74142 9.37075 6.32104",
  stroke: "#2F9BFF",
  strokeWidth: 1.5
});

function SvgTurbine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurbine);
export default __webpack_public_path__ + "static/media/turbine.367d1714.svg";
export { ForwardRef as ReactComponent };